import axios from "axios";
import Vue from "vue";
axios.interceptors.request.use(request => {
  return request;
});

axios.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      Vue.prototype.$Message.error({
        content: "好像哪里出错了惹"
      });
    }
    return response;
  },
  err => {
    if (err) {
      Vue.prototype.$Message.error({
        content: err.message
      });
      return Promise.reject(err);
    }
  }
);
/**
 * 个股经纪商持股查询
 *
 * @param {Object} param0
 * @param {String} stockCode 股票代码
 * @param {String} time 时间戳🐱
 *
 */
const GetCassStockBroker = ({ stockCode, time }: any) =>
  axios.get(`/ccass/stock/broker?time=${time}&stockCode=${stockCode}`);

/**
 * 个股经纪商持股变动查询
 *
 * @param {Object} param0
 * @param {String} param0.stockCode 股票代码
 * @param {String} param0.startTime 开始时间戳🐱
 * @param {String} param0.endTime 结束时间戳🐱
 *
 */
const GetCassStockBrokerChange: GAPI.GetCassStockBrokerChange = ({
  stockCode,
  startTime,
  endTime
}: GAPI.GetCassStockBrokerChangeRequest) =>
  axios.get<GAPI.GetCassStockBrokerChangeResponse>(
    `/ccass/stock/broker/change?stockCode=${stockCode}&startTime=${startTime}&endTime=${endTime}`
  );

/**
 * 个股经纪商持股分布图
 * @param {object} param0
 * @param {String} param0.stockCode 股票代码
 *
 */
const GetCassStockBrokerProfile = ({
  stockCode
}: GAPI.GetCassStockBrokerProfileRequest) =>
  axios.get<GAPI.GetCassStockBrokerProfileResponse>(
    `/ccass/stock/broker/concentration?stockCode=${stockCode}`
  );

/**
 * 个股经纪商单持股变动图
 * @param {object} param0
 * @param {String} param0.stockCode 股票代码
 * @param {String} param0.participantId 经纪商代码
 *
 */
const GetCassStockBrokerChangeDetail = ({ stockCode, participantId }: any) =>
  axios.get(
    `/ccass/stock/broker/change/detail?stockCode=${stockCode}&participantId=${participantId}`
  );
/**
 * 获取券商持股总览
 *
 * @param {object} param0
 * @param {string} time 时间戳🐱
 *
 */
const GetCassBrokersViews = ({ time }: GAPI.GetCassBrokersViewsRequest) =>
  axios.get<GAPI.participantOverviewItem[]>(
    `/ccass/participant/holding/overview?time=${time}`
  );

/**
 * 席位持股查询
 *
 * @param {*} param0
 * @param {string} time 时间戳🐱
 * @param {String} participantId 经纪商代码
 *
 */
const GetCassBrokersChange: GAPI.GetCassBrokersChange = ({
  time,
  participantId
}) =>
  axios.get(
    `/ccass/participant/holding?time=${time}&participantId=${participantId}`
  );

const GetCassBrokersHoldingChange = ({
  startTime,
  participantId,
  endTime
}: any) =>
  axios.get(
    `/ccass/participant/holding/change?startTime=${startTime}&participantId=${participantId}&endTime=${endTime}`
  );
/**
 * 获取龙虎榜数据
 */
const GetBoardLonghu: GAPI.GetBoardLonghu = () =>
  axios.get<GAPI.GetBoardLonghuResponse>(`/ccass/boards/long-hu`);

/**
 * 股票代码搜索 🔍
 *
 * @param {String} code 股票代码
 */
const GetStockList: GAPI.GetStockList = (code: string) =>
  axios.get<GAPI.StockList>(`/gapi/search/hkstock?keyword=${code}`);

export default {
  GetCassStockBroker,
  GetCassStockBrokerChange,
  GetCassStockBrokerChangeDetail,
  GetCassStockBrokerProfile,
  GetCassBrokersViews,
  GetCassBrokersChange,
  GetCassBrokersHoldingChange,
  GetBoardLonghu,
  GetStockList
};
